import { OutsourceState } from '../../../../shared/model/OutsourceState';

export class OutsourceSearchRequest {

    _page; // number
    _term; // string
    _state; // number

    constructor() {
        this._page = 1;
        this._term = '';
        this._state = OutsourceState.ALL;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state = state;
    }

    body() {
        return {
            retrieve_document_stats: true,
            criteria: {
                page: this._page,
                term: this._term,
                only_active: this._state === OutsourceState.ACTIVE,
                only_inactive: this._state === OutsourceState.INACTIVE,
                show_only_deleted: false,
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/outsource-search/OutsourceSearchRequest.js